module.exports = __webpack_public_path__ + "assets/b6d076e19d883b1e89ab3e6ae9acddaf.mp3";